import { type RefObject, useEffect } from 'react';

import type { EventListenerOptions } from './EventManager';
import type { SwimlaneEventListener, SwimlaneEvents } from './events';
import type { SwimlaneApi } from './types';

export const useSwimlaneEventHandler = <E extends SwimlaneEvents>(
  apiRef: RefObject<SwimlaneApi>,
  eventName: E,
  handler: SwimlaneEventListener<E>,
  options?: EventListenerOptions,
) =>
  useEffect(
    () =>
      // `subscribeEvent` returns unsubscribe function
      apiRef.current.subscribeEvent(eventName, handler, options),
    [apiRef, eventName, handler, options],
  );
